import saveAs from "file-saver";

interface ColumnNameConfig<T> {
  header: string;
  field: keyof T; 
  format?: (val: T[keyof T]) => string | number;
  csvFormat?: (val: T[keyof T]) => string; 
};

const formatTableForCSV = <T>(data: T[], columns: ColumnNameConfig<T>[]) => {
  let result = [];
  const header = columns.map(col => col.header);
  result.push(header);

  data.forEach(row => {
    const dataRow = columns.map(col => {
      const formatted = col.csvFormat ? col.csvFormat(row[col.field]) : col.format ? col.format(row[col.field]) : String(row[col.field]);
      return `"${String(formatted).replace(/"/g, '""')}"`;
    });
    result.push(dataRow);
  });

  return result;
};

export const generateFilename = (title: string, startDate?: Date, endDate?: Date, year?: number) => {
  if (year) {
    return `${title.replace(/\s+/g, '_')}_${year}.csv`;
  }
  
  let start: string | undefined;
  let end: string | undefined;
  if (startDate && endDate) {
    start = startDate?.toLocaleDateString("de-DE");
    end = endDate?.toLocaleDateString("de-DE");
  } else if (startDate) { // for when downloading the estimated revenue table
    start = startDate?.toLocaleDateString("de-DE");
    end = new Date().toLocaleDateString("de-DE");
  }
  
  return `${title.replace(/\s+/g, '_')}_${start}_bis_${end}.csv`;
};

export const downloadCSV = <T>(data: T[], columns: ColumnNameConfig<T>[], filename: string, returnString?: boolean): string | void => {
  // format data
  const formattedData = formatTableForCSV(data, columns);

  const BOM = '\uFEFF';
  const csv = formattedData.map(row => row.join(';')).join('\n');
  const csvWithBOM = BOM + csv;

  // If returnString is true, return the CSV string instead of downloading
  if (returnString) {
    return csvWithBOM;
  }

  // Otherwise, download the file
  const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8' });
  saveAs(blob, filename);
};